/* eslint-disable */
import '../../blocks/gallery/gallery';
import '../../blocks/applications-areas/applications-areas';

document.addEventListener('click', (e) => {
  const title = e.target.closest('.js-accordion-title');
  if (!title || window.innerWidth > 1023) return;

  const column = title.closest('.specs-item__container');
  const content = column.querySelector('.js-accordion-content');

  const isOpen = column.classList.contains('open');

  if (isOpen) {
    content.style.height = content.scrollHeight + 'px';
    requestAnimationFrame(() => {
      content.style.height = '0px';
    });
    column.classList.remove('open');
  } else {
    content.style.height = content.scrollHeight + 'px';
    column.classList.add('open');

    content.addEventListener('transitionend', function handler() {
      content.style.height = 'auto';
      content.removeEventListener('transitionend', handler);
    });
  }
});

document.addEventListener('DOMContentLoaded', () => {
  const product = document.querySelector('.js-product-main-class');
  if (!product) return;

  const dataClass = product.dataset.class;

  if (dataClass !== 'light-towers') {
    const wrapper = product.closest('.content-wrapper');
    if (wrapper) {
      wrapper.classList.add('accessories');
    }
  }
});
